import type { ConnectedPosition } from '@angular/cdk/overlay';
import type { OnDestroy } from '@angular/core';
import { Injectable } from '@angular/core';

import type {
  OverlayPosition,
  PlaceholderDropdownListController,
  PlaceholderNavigationKey,
} from '@core/prosemirror-legacy';
import { WysiwygComponentPortalService } from '@core/prosemirror-legacy/angular';
import type { Placeholder } from '@core/wysiwyg-legacy';

import { PlaceholderDropdownComponent } from './placeholder-dropdown.component';

@Injectable()
export class PlaceholderDropdownService
  extends WysiwygComponentPortalService<PlaceholderDropdownComponent>
  implements PlaceholderDropdownListController, OnDestroy
{
  protected overlayConfig = {
    hasBackdrop: true,
    backdropClass: 'cdk-overlay-transparent-backdrop',
  };

  private restoreFocusCallback?: () => void;

  public open(
    position: OverlayPosition | DOMRect,
    _options: {
      preferredPositions?: ConnectedPosition[];
      nestedList?: boolean;
    },
  ) {
    const options = {
      preferredPositions: _options.preferredPositions || [],
      nestedList: _options.nestedList || false,
    };
    this.close();
    this.openComponent(PlaceholderDropdownComponent, position, options.preferredPositions);
    const { instance, location } = this.componentRef!;
    instance.nestedList = options.nestedList;
    instance.close = () => {
      this.close();
      this.restoreFocusCallback?.();
    };
    return {
      element: <HTMLElement>location.nativeElement,
      backdropClick$: this.overlayRef!.backdropClick(),
    };
  }

  public setSelectCallback(selectCb: (val: Placeholder) => void): void {
    if (!this.componentRef) return;
    this.componentRef.instance.select = selectCb;
  }

  public setData(data: Placeholder[]): void {
    if (!this.componentRef) return;

    this.componentRef.instance.data = data;
    this.componentRef.changeDetectorRef.detectChanges();
    this.overlayRef!.updatePosition();
  }

  public handleKey(key: PlaceholderNavigationKey) {
    this.componentRef?.instance.handleKey(key);
  }

  public registerRestoreFocus(restoreFocusCallback: () => void) {
    this.restoreFocusCallback = restoreFocusCallback;
  }
}
